import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ProfileLogo from '~/components/office/ProfileLogo';
import { Link } from '~/components/ui/Link';
import { cn } from '~/helpers/utils';
import { OfficeDetails } from '~/types/Office';

type CalculationOfficeProps = {
  office: OfficeDetails;
};

const CalculationOffice: React.FC<CalculationOfficeProps> = ({ office }) => {
  return (
    <div
      className={cn(
        'relative rounded-b-lg bg-blue-700',
        '-mx-6 -mb-6 mt-6 p-6',
        'md:-mx-8 md:-mb-8 md:px-8',
        'md:-mb-10 md:px-10 xl:-mx-10'
      )}
    >
      <div className="flex items-center gap-6">
        <div className="self-start">
          <ProfileLogo
            src={office.logoUrl}
            alt={`Logo van ${office.name}`}
            widthClass="w-10 h-10 lg:w-14 lg:h-14"
          />
        </div>
        <div>
          <div className="flex min-h-20 flex-col justify-center gap-1 text-balance text-sm text-white">
            <span className="font-display text-xs">Gekozen advieskantoor</span>
            <span className="font-display text-lg font-bold">
              {office.name}
            </span>
          </div>
        </div>
      </div>
      <div className="xl-mh:flex-row xl-mh:gap-4 mt-4 flex flex-col items-center gap-2 md:flex-row md:gap-4 xl:flex-col xl:gap-2">
        <Link
          size="small"
          className="w-full text-xs font-bold 2xl:h-12 2xl:w-auto 2xl:px-6 2xl:text-sm"
          variant="blue"
          href={`/hypotheekadvies/${office.address.zipcode}/${office.slug}/`}
        >
          <FontAwesomeIcon icon={faArrowLeft as IconProp} />
          Terug naar profiel
        </Link>
        <Link
          size="small"
          className="w-full text-xs font-bold 2xl:h-12 2xl:w-auto 2xl:px-6 2xl:text-sm"
          variant="primary"
          href={`/hypotheekadvies/${office.address.zipcode}/${office.slug}/adviesgesprek`}
        >
          Maak direct een afspraak
          <FontAwesomeIcon icon={faArrowRight as IconProp} />
        </Link>
      </div>
    </div>
  );
};

export default CalculationOffice;
